
export const copyToClipboard = (docURl) => {
    var input = document.body.appendChild(document.createElement("input"));
    const url = window.location.href;
    input.value = docURl != '' ? docURl : url ;
    input.select();
    document.execCommand('copy');
    input.parentNode.removeChild(input);
}